module.exports = __webpack_public_path__ + "img/vertical-propane-tank.6d97bff8.jpg";